interface State {
  env: string
  envInfo: Record<string, unknown>
  amsConfig: Record<string, any>
}
const state: State = {
  env: window.localStorage.getItem('env') || '',
  envInfo: JSON.parse(window.localStorage.getItem('envInfo') || '{}'),
  amsConfig: JSON.parse(window.localStorage.getItem('amsConfig') || '{}')
}

const mutations = {
  setEnv(state: State, env: string) {
    state.env = env
    window.localStorage.setItem('env', env)
  },
  setEnvInfo(state: State, envInfo: Record<string, unknown>) {
    state.envInfo = envInfo
    window.localStorage.setItem('envInfo', JSON.stringify(envInfo))
  },
  setAmsConfig(state: State, amsConfig: Record<string, any>) {
    state.amsConfig = amsConfig
    window.localStorage.setItem('amsConfig', JSON.stringify(amsConfig))
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
